export interface ClientAgentAliasDto{
    ClientAgentAliasId: Guid;
    ClientAgentId: number;
    PrimaryAlias: boolean;
    AgentAlias: string;
}

export class ClientAgentAliasDto implements ClientAgentAliasDto {
    ClientAgentAliasId = "";
    ClientAgentId = 0;
    PrimaryAlias = false;
    AgentAlias = "";
  }